import styled from 'styled-components';

import { ChevronIcon, CloseIcon } from '../../../assets';
import { ThemeProp } from '../../../theme/Themes';
import { determineBreakpoint } from '../../../theme/utils';
import IconButton from '../../Button/IconButton';
import { BottomSheetChangeBreakpoint } from '../Modal';

interface Center {
  $centerTitle?: boolean;
}

export const HeaderContainer = styled.div<Center>`
  display: flex;
  width: 100%;
  justify-content: ${(props: Center) => (props.$centerTitle ? 'center' : 'flex-start')};
  position: relative;
  padding: 0.5rem 1.5rem 0;
  @media (min-width: ${(props) => props.theme.breakpoints.minMobile}) {
    padding: 1.5rem 1.5rem 0 1.5rem;
  }
`;

export const Title = styled.span<
  {
    $goBackButtonIsVisible?: boolean;
    $mobileMarginBottom?: string;
    $bottomSheetChangeBreakpoint?: BottomSheetChangeBreakpoint;
  } & Center
>`
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.medium};
  font-size: ${(props: ThemeProp) => props.theme.fontVariants.desktop.h3.fontSize};
  line-height: ${(props: ThemeProp) => props.theme.fontVariants.desktop.h3.lineHeight};
  align-self: flex-end;
  text-align: ${(props: Center) => (props.$centerTitle ? 'center' : 'left')};
  color: ${(props: ThemeProp) => props.theme.colors.white};
  ${(props) => props.$goBackButtonIsVisible && 'padding-left: 1.5rem;'}

  @media (max-width: ${(props) => determineBreakpoint(props)}) {
    margin-bottom: ${(props) => props.$mobileMarginBottom || '1.5rem'};
  }
`;

export const Row = styled.div``;

export const CloseButton = styled(IconButton)`
  position: absolute;
  width: 1.5rem;
  height: 1.5rem;
  top: 0;
  right: 1rem;
  svg {
    stroke: ${(props) => props.theme.colors.greyscale.c100};
  }

  @media (min-width: ${(props: ThemeProp) => props.theme.breakpoints.minMobile}) {
    right: 1.5rem;
    top: 1.5rem;
    svg {
      width: 2rem;
      height: 2rem;
    }
  }
`;

export const StyledCloseIcon = styled(CloseIcon)`
  stroke: ${(props: ThemeProp) => props.theme.colors.greyscale.c100};
`;

export const GoBackButton = styled(IconButton)`
  position: absolute;
  width: 1.5rem;
  height: 1.5rem;
  top: 0.7rem;
  left: 1rem;
  svg {
    stroke: ${(props: ThemeProp) => props.theme.colors.greyscale.c100};
    width: 0.75rem;
    height: 0.75rem;
  }

  &:hover {
    background: ${(props: ThemeProp) => props.theme.colors.greyscale.c800};
    svg {
      stroke: ${(props: ThemeProp) => props.theme.colors.greyscale.c100};
    }
  }

  @media (min-width: ${(props: ThemeProp) => props.theme.breakpoints.minMobile}) {
    left: 1rem;
    top: 1.65rem;
  }
`;

export const StyledChevronIcon = styled(ChevronIcon)`
  stroke: ${(props: ThemeProp) => props.theme.colors.greyscale.c100};
  transform: rotate(90deg);
`;
